import { render } from "./PageLayoutWithTopBar.vue?vue&type=template&id=c9575a8a&scoped=true"
import script from "./PageLayoutWithTopBar.vue?vue&type=script&lang=js"
export * from "./PageLayoutWithTopBar.vue?vue&type=script&lang=js"

import "./PageLayoutWithTopBar.vue?vue&type=style&index=0&id=c9575a8a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9575a8a"]])

export default __exports__